import styled from 'styled-components';

export const TableWidgetStyled = styled.div`
  width: 100%;
  height: 100%;
`;
